module.exports = __webpack_public_path__ + "media/images/area/feature/tohoku/related/zh-hans/2-506eb6e29fd1d13a3ad1765c6f55c2fc.jpg";